import { useEffect } from "react";
import {
  captureClickIdsFromSearch,
  getAllPersistedClickIds,
  resolveUtmParam,
} from "~/helpers/clickIds";

export const useUTM = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const capturedClickIds = captureClickIdsFromSearch(searchParams);

    const utmCampaign = resolveUtmParam(
      searchParams,
      "utm_campaign",
      "utm_campaign_name"
    );
    const utmCampaignid = resolveUtmParam(
      searchParams,
      "utm_campaignid",
      "utm_campaign_id",
      "campaignid"
    );
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmTerm = resolveUtmParam(searchParams, "utm_term", "keyword");
    const utmContent = searchParams.get("utm_content");
    const utmMediumVariant = searchParams.get("utm_medium_variant");
    const utmDevice = searchParams.get("utm_device");
    const utmNetwork = searchParams.get("utm_network");
    const utmPlacement = searchParams.get("utm_placement");
    const utmLocPhysical = searchParams.get("utm_loc_physical");
    const utmAdgroup = resolveUtmParam(
      searchParams,
      "utm_adgroup",
      "utm_adgroup_name",
      "utm_adgroup_id",
      "adgroupid"
    );
    const utmAssetgroupid = searchParams.get("utm_assetgroupid");
    const utmCreative = searchParams.get("utm_creative");
    const utmKeyword = resolveUtmParam(
      searchParams,
      "utm_keyword",
      "keyword",
      "utm_term"
    );
    const utmKeywordid = searchParams.get("utm_keywordid");
    const utmSearchterm = searchParams.get("utm_searchterm");
    const utmMatchtype = resolveUtmParam(
      searchParams,
      "utm_matchtype",
      "matchtype"
    );
    const utmLocation = searchParams.get("utm_location");
    const utmSitelink = searchParams.get("utm_sitelink");

    const hasUtms = !!(
      utmCampaign ||
      utmCampaignid ||
      utmSource ||
      utmMedium ||
      utmTerm ||
      utmContent ||
      utmMediumVariant ||
      utmDevice ||
      utmNetwork ||
      utmPlacement ||
      utmLocPhysical ||
      utmAdgroup ||
      utmAssetgroupid ||
      utmCreative ||
      utmKeyword ||
      utmKeywordid ||
      utmSearchterm ||
      utmMatchtype ||
      utmLocation ||
      utmSitelink
    );

    if (!hasUtms && !Object.keys(capturedClickIds).length) return;

    // Only write UTM keys that arrived on this landing (avoid blanking first-touch)
    const utmWrites: Array<[string, string | null]> = [
      ["utm_campaign", utmCampaign],
      ["utm_campaignid", utmCampaignid],
      ["utm_source", utmSource],
      ["utm_medium", utmMedium],
      ["utm_term", utmTerm],
      ["utm_content", utmContent],
      ["utm_medium_variant", utmMediumVariant],
      ["utm_device", utmDevice],
      ["utm_network", utmNetwork],
      ["utm_placement", utmPlacement],
      ["utm_loc_physical", utmLocPhysical],
      ["utm_adgroup", utmAdgroup],
      ["utm_assetgroupid", utmAssetgroupid],
      ["utm_creative", utmCreative],
      ["utm_keyword", utmKeyword],
      ["utm_keywordid", utmKeywordid],
      ["utm_searchterm", utmSearchterm],
      ["utm_matchtype", utmMatchtype],
      ["utm_location", utmLocation],
      ["utm_sitelink", utmSitelink],
    ];

    for (const [key, value] of utmWrites) {
      if (value) {
        localStorage.setItem(key, value);
      }
    }
  }, []);

  const getUTM = (key: string) => {
    const value = localStorage.getItem(key);
    if (!value) return null;
    return value;
  };

  const clickIds = getAllPersistedClickIds();

  return {
    campaign: getUTM("utm_campaign"),
    campaignid: getUTM("utm_campaignid"),
    source: getUTM("utm_source"),
    medium: getUTM("utm_medium"),
    term: getUTM("utm_term"),
    content: getUTM("utm_content"),
    medium_variant: getUTM("utm_medium_variant"),
    device: getUTM("utm_device"),
    network: getUTM("utm_network"),
    placement: getUTM("utm_placement"),
    loc_physical: getUTM("utm_loc_physical"),
    adgroup: getUTM("utm_adgroup"),
    assetgroupid: getUTM("utm_assetgroupid"),
    creative: getUTM("utm_creative"),
    keyword: getUTM("utm_keyword"),
    keywordid: getUTM("utm_keywordid"),
    searchterm: getUTM("utm_searchterm"),
    matchtype: getUTM("utm_matchtype"),
    location: getUTM("utm_location"),
    sitelink: getUTM("utm_sitelink"),
    gclid: clickIds.gclid,
    gbraid: clickIds.gbraid,
    wbraid: clickIds.wbraid,
  };
};
